import { connect } from 'react-redux'
import React, { Component } from 'react'
import { browserHistory, Link } from 'react-router'
import BlueLogo from '../../assets/newblacklogo.png'
import { changePlan } from '../../actions'
import Plan from './Plan'
import './landing.css'
import { Helmet } from "react-helmet";

const mapStateToProps = (state, ownProps) => ({
  me: state.me,
})
  
class Pricing extends Component {
  constructor() {
    super()
    this.setState = this.setState.bind(this)
  }

  checkOut(plan) {
    const { query } = this.props.viewParams

    const key = process.env.REACT_APP_STRIPE_KEY
    const props = {
      billingAddressCollection:'auto',
      clientReferenceId:this.props.me.user_name,
      items: [{
        plan: plan,
        quantity: 1
      }],
      successUrl: `https://${key.includes('test_') ? 'staging.' : ''}streamable.com?alert=${plan}&checkout=true&src_internal=${query.src_internal}`,
      cancelUrl: `https://${key.includes('test_') ? 'staging.' : ''}streamable.com/pricing?checkout=false&src_internal=cancelled-stripe-checkout`
    }
    if (this.props.me.user_name.includes('@')) {
      props['customerEmail'] = this.props.me.user_name; 
    }
    window.Stripe(key).redirectToCheckout(props);
  }

  render() {
    const { me, viewParams } = this.props
    const { query } = viewParams
    
    let buttonText = ['Get Started', "Start 7 Day Trial", "Start 7 Day Trial"]
    let buttonDisabled = [false, false, false]
    let buttonAction = [null, null, null]

    const isPro = me.plan && me.plan != '';
    if (me.user_name && !isPro) {
      buttonText[0] = 'Current Plan';
      buttonDisabled[0] = true;
    } else if (isPro && (me.plan == 'streamable-pro' || me.plan == 'basic-monthly')) {
      buttonText = ['Downgrade', "Current Plan", "Upgrade"]
      buttonAction = ['downgrade', null, 'upgrade']
      buttonDisabled[1] = true;
    } else if (isPro && (me.plan == 'streamable-business' || me.plan == 'pro-monthly')) {
      buttonText = ['Downgrade', "Downgrade", "Current Plan"]
      buttonAction = ['downgrade', 'downgrade', null];
      buttonDisabled[2] = true;
    }

    return (
      <div className="landing pricing">
        <Helmet>
          <title>Pricing - Streamable</title>
          <meta name="description" content="Sign up for a free account or upgrade to one of our paid plans."></meta>
          <link rel="canonical" href={`https://streamable.com/pricing`} />
        </Helmet>
        <nav className="navbar navbar-default" ref={r => this.navRef = r}>
          <ul className="nav navbar-nav">
            <li>
              <a href="https://streamable.com" className="nav-btn">
                <img className="logo" src={BlueLogo} role="presentation" />
              </a>
            </li>
          </ul>
          <ul className="nav navbar-nav float-right">
            <span>
              {this.props.me.user_name ? "" :
              <li>
                <Link to="/login" className="nav-btn login-btn">
                  Log In
                </Link>
                <Link to="/signup" className="nav-btn signup-btn">
                  Sign Up
                </Link>
              </li>
              }
            </span>
          </ul>
          
        </nav>
        <div className="header">
          <h1>Choose a plan.</h1>
        </div>
        <div className="plans">
          <Plan 
            title="Basic"
            cost="Free"
            items={['Inactive videos removed', 'Ads display on your videos', 'Embedded videos stream in SD', '10 minute maximum video duration']}
            action={buttonText[0]}
            disabled={buttonDisabled[0]}
            onClick={async () => {
              if (this.props.me.user_name) {
                if (isPro) {
                  await this.props.dispatch(changePlan(null))
                }
                browserHistory.push('/videos?alert=' + buttonAction[0])
              } else {
                browserHistory.push('/signup')
              }
            }}
          >
          </Plan>
          <Plan title="Pro" cost={me.plan == 'basic-monthly' ? '$5' : "$9"} 
            items={['Videos stored forever', 'No ads on your videos', 'Embedded videos stream in HD', '10 minute maximum video duration']}
            action={buttonText[1]}
            disabled={buttonDisabled[1]}
            onClick={async () => {
              if (this.props.me.user_name) {
                if (isPro) {
                  await this.props.dispatch(changePlan('streamable-pro'))
                  browserHistory.push('/videos?alert=' + buttonAction[1])
                } else {
                  this.checkOut('streamable-pro')
                }
              } else {
                browserHistory.push(`/signup?plan=streamable-pro`)
              }
            }}
          >
          </Plan>
          <Plan title="Business" cost="$29" 
            items={['Videos stored forever', 'No ads on your videos', 'Embedded videos stream in HD', '30 minute maximum video duration']}
            action={buttonText[2]}
            disabled={buttonDisabled[2]}
            onClick={async () => {
              if (this.props.me.user_name) {
                if (isPro) {
                  await this.props.dispatch(changePlan('streamable-business'))
                  browserHistory.push('/videos?alert=' + buttonAction[2])
                } else {
                  this.checkOut('streamable-business')
                }
              } else {
                browserHistory.push(`/signup?plan=streamable-business`)
              }
            }}
          >
          </Plan>
        </div>
        <div className="faq">
        <div className="faq-question">
            Will people see ads on my videos?
          </div>
          <div className="faq-answer">
            Viewers will never see ads on your videos with the Pro or Business plans. With the free plan, ads will appear on your videos as soon as they become popular.
          </div>
          <div className="faq-question">
            How long are videos stored?
          </div>
          <div className="faq-answer">
            On the free plan, videos that are inactive for 3 months are deleted in order to make room for new content. For paid plans, videos are deleted only upon request.
          </div>
          <div className="faq-question">
            Can I cancel my plan?
          </div>
          <div className="faq-answer">
            Yes, all of our plans are zero-commitment and can be cancelled at any time. If you decide to cancel during a 7-day trial, you won't pay anything.
          </div>
          <div className="faq-question">
            Are there any upload caps or limits?
          </div>
          <div className="faq-answer">
            There are no caps or limitations on how many videos you can upload with any of our plans (free or paid).
          </div>
          <div className="faq-question">
            What kind of content can I upload?
          </div>
          <div className="faq-answer">
            Whatever you like! As long as it's not violence, gore, or adult content. To share some types of content, like video game replays, you will need to sign up for a plan.
          </div>
          <div className="faq-question">
            What if I need a different plan?
          </div>
          <div className="faq-answer">
            Please email <a href="mailto:sales@streamable.com?Subject=Custom%20plan">sales@streamable.com</a> to set up a custom plan.
          </div>
        </div>
        <footer className="footer">
          <div className="container-fluid">
            <ul className="nav navbar-nav">
              <li>
                <a href="//privacy.streamable.com">
                  Privacy
                </a>
              </li>
              <li>
                <a href="//terms.streamable.com">
                  Terms
                </a>
              </li>
              <li>
                <a href="https://support.streamable.com">
                  Support
                </a>
              </li>
            </ul>
          </div>
        </footer>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Pricing)
